// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tw-0";
export var checkoutRateBadgeLink = "_tw-1";